import { Option, Select as TailwindSelect } from "@material-tailwind/react";
import { v4 as uuid } from "uuid";

import * as S from "./styled";

export const Select = ({
  variant = "standard",
  items = [],
  itemKey,
  register = {},
  customClassName,
  containerClassName,
  labelClassName,
  error,
  ...rest
}) => {
  return (
    <S.Container className={`${containerClassName} ${customClassName ? "single-row" : ""}`}>
      <TailwindSelect
        className={"[&>ul]:!max-h-[200px]"}
        color="green"
        error={!!error}
        style={{ fontFamily: "Montserrat", maxWidth: "180px" }}
        variant={variant}
        {...register}
        {...rest}
        labelProps={{
          className: labelClassName,
        }}
      >
        {items.map((item) => (
          <Option key={uuid()} value={itemKey ? item[itemKey] : item}>
            {itemKey ? item[itemKey] : item}
          </Option>
        ))}
      </TailwindSelect>
      {error && <S.ErrorText>{error.message}</S.ErrorText>}
    </S.Container>
  );
};
